module.exports = __webpack_public_path__ + "media/printed-materials/image002-23471d56.png";